<template>
  <div class="hand-runs">
    <div
      v-for="(run, i) in runs"
      :key="`run-${run[0]}-${i}`"
      class="run"
      :title="runTitle(run)"
    >
      <!--
        tabindex -1: a tap focuses the card (phones don't reliably give a
        plain image :hover), without adding every chip to the tab order.
        The stylesheet lifts a hovered or focused card - see `.run`.
      -->
      <CardFace v-for="value in run" :key="value" :value="value" tabindex="-1" />
    </div>
    <span v-if="runs.length === 0" class="counter-band">no cards</span>
  </div>
</template>

<script>
import { groupIntoRuns } from '@/engine/scoring';
import CardFace from './CardFace.vue';

// A player's taken cards, grouped the way they actually score.
//
// "When you collect cards that form a series, place them face-up so that they
// overlap, but so that players can still see the numbers in the corners."
// (p3) - the overlap is in the CSS, and it isn't decoration: a run is one
// scoring unit worth its lowest card, and seeing 20-21-22 as a single block
// rather than three separate cards is the difference between reading your
// position at a glance and doing arithmetic.
export default {
  name: 'CardRuns',
  components: { CardFace },
  props: {
    cards: { type: Array, required: true },
  },
  computed: {
    runs() { return groupIntoRuns(this.cards); },
  },
  methods: {
    runTitle(run) {
      return run.length > 1
        ? `${run.join('-')} — scores ${run[0]}`
        : `${run[0]} — scores ${run[0]}`;
    },
  },
};
</script>
